<template>
    <div class="row" style="margin-top: 3px;" :id="this.oid">

        <!-- Option Properties -->
        <div class="col-md-2 quiz-left-column option-row"
             v-bind:class="{'text-success': isCorrect, 'text-danger': !isCorrect}">
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][oid]'" :value="oid"/>
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][isCorrect]'" :value="isCorrect"/>

            <i class="fa" v-bind:class="{'fa-check': isCorrect, 'fa-times': !isCorrect}"></i>
            <span><b>{{isCorrect ? 'Correct' : 'Incorrect'}}</b></span><br/>
            <span style="font-weight: bold; color: #444" v-if="isSuggestedAnswer">Suggested Answer</span>
        </div>

        <!-- Option Text -->
        <div class="col-md-5 quiz-text-column option-row">
            <span dir="auto">{{XX_en}}</span>
        </div>
        <div class="col-md-5 quiz-text-column option-row">
            <input type="hidden"
                   :name="'questions['+questionIdx+'][options]['+idx+'][text]['+locale+']'"
                   :value="localization"/>
            <input type="text"
                   :title="locale"
                   dir="auto"
                   v-model="localization"
                   onfocus="preview(this.value);"
                   @keyup="changeOptionText(localization)"/>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            'idx': Number,
            'oid': String,
            'questionIdx': Number,
            'locale': String,
            'isCorrect': Boolean,
            'XX_en': String,
            'ilocalization': String,
            'isSuggestedAnswer': Boolean,
        },

        data: function() {
            return {
                localization: this.ilocalization,
                updateTimer: null,  // make sure that we don't add multiple options when typing very fast
            };
        },

        methods: {
            changeOptionText: function(text) {
                // make sure that we don't add multiple options when typing very fast
                if (this.updateTimer !== null) {
                    window.clearTimeout(this.updateTimer);
                }

                let vm = this;

                this.updateTimer = window.setTimeout(function() {
                    preview(text);
                    vm.$emit('typingOption');
                }, 50);

            },
        },
    };
</script>
